import { Form, Input, InputNumber, Select, Spin } from "antd";
import React, { useRef, useState } from "react";
import PhoneInput from "react-phone-input-2";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ndovu from "../../../assets/svg/ndovu.svg";
import { fetchBanks } from "../../../features/fetch/fetchSlice";
import { save } from "../../../features/save/saveSlice";
import toast from "react-hot-toast";

function BankForm() {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { saving } = useSelector((state) => state.save);
  const handleCancel = () => {
    navigate("/commissions");
  };
  const { dropLoading, banks } = useSelector((state) => state.fetch);

  const [bankCode, setBankCode] = useState();
  const [accntNumber, setAccntNumber] = useState();
  async function handleValidValidate() {
    if (!bankCode) {
      toast.error("Please select a bank");
      return;
    }
    if (!accntNumber) {
      toast.error("Please provide a bank number");
      return;
    }
    if (bankCode && accntNumber) {
      const res = await dispatch(
        save({
          url: "api/v2/manualPayment/validate-account",
          bankCode: bankCode,
          beneficiaryAccount: accntNumber,
        })
      );
      if (res?.payload?.data?.result?.status === "SUCCESS") {
        form.setFieldsValue({
          manualPaymentBeneficiaryDetails: res?.payload?.data?.result?.benName,
        });
      } else {
        await form.setFieldsValue({
          manualPaymentBeneficiaryDetails: null,
        });
        await toast.error("Account not found type the account name");
      }
    }
  }

  const onFinish = async (data) => {
    const res = await dispatch(
      save({
        ...data,
        url: "api/v1/commission/save-withdrawal",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  async function fetchBanksData() {
    await dispatch(
      fetchBanks({
        url: "api/v1/payments/fetch-banks",
      })
    );
  }
  return (
    <Form
      layout="vertical"
      ref={formRef}
      name="control-ref"
      onFinish={onFinish}
      className="lg:w-[700px] w-full lg:mt-0 mt-5"
      style={{
        maxWidth: "100%",
      }}
      form={form}
    >
      <div className="flex items-center lg:gap-x-5">
        <Form.Item
          name="cwBank"
          className="w-full"
          label={<span>Bank</span>}
          rules={[
            {
              required: true,
              message: "Please select Bank",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              banks?.length > 0 &&
              banks?.map((item) => ({
                value: item?.bnkId,
                label: item?.bnkName,
              }))
            }
            onChange={(value) => {
              const selectedItem = banks?.find(
                (item) => item?.bnkId === value
              );
              setBankCode(selectedItem?.bnkNo || "");
            }}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
            onDropdownVisibleChange={() => {
              fetchBanksData();
            }}
            dropdownRender={(menu) => (
              <>
                {dropLoading && (
                  <div
                    style={{
                      padding: "8px",
                      textAlign: "center",
                    }}
                  >
                    <Spin className="sms-spin" />
                  </div>
                )}
                {menu}
              </>
            )}
          />
        </Form.Item>

        <Form.Item
          className="w-full"
          name="cwAccount"
          label="Account Number"
          rules={[
            {
              required: true,
              message: "Enter Account Number",
            },
          ]}
        >
          <Input
            onChange={(e) => {
              setAccntNumber(e.target.value);
            }}
            className="input"
          />
        </Form.Item>

        <div className="w-[100px]">
          <button
            type="button"
            className="cstm-btn-2 !rounded-[10px]"
            disabled={saving}
            onClick={handleValidValidate}
          >
            {saving ? <Spin /> : "Validate"}
          </button>
        </div>
      </div>
      <Form.Item
        name="cwDetails"
        label="Account Name"
        rules={[
          {
            required: true,
            message: "Enter Account Name",
          },
        ]}
      >
        <Input disabled={saving} className="input" />
      </Form.Item>

      <div className="flex justify-between mt-[60px] mb-[48px] items-center">
        <div className="w-[150px]">
          <button
            disabled={saving}
            key="submit"
            type="submit"
            className="cstm-btn-2"
          >
            {saving ? <Spin /> : "Submit"}
          </button>
        </div>
      </div>
    </Form>
  );
}

export default BankForm;
